<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          v-if="permission('read', 'resident_nurse_schedule')"
          @click="handleStep('APRAZAMENTO_NORMAL')"
          :class="[
            'nav-link link-nav-resident',
            step == 'APRAZAMENTO_NORMAL' && 'active',
          ]"
          id="nav-aprazamento-normal"
          data-toggle="tab"
          href="#aprazamento-normal"
          role="tab"
          aria-controls="aprazamento-normal"
          aria-selected="true"
          >APRAZAMENTO</a
        >
        <a
          v-if="permission('read', 'resident_nurse_schedule')"
          @click="handleStep('APRAZAMENTO_LONGO_PRAZO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'APRAZAMENTO_LONGO_PRAZO' && 'active',
          ]"
          id="nav-aprazamento-longo-prazo"
          data-toggle="tab"
          href="#aprazamento-longo-prazo"
          role="tab"
          aria-controls="aprazamento-longo-prazo"
          aria-selected="true"
          >APRAZAMENTO LONGO PRAZO</a
        >
        <a
          v-if="permission('read', 'evolution_nursing')"
          @click="handleStep('EVOLUCAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'EVOLUCAO' && 'active',
          ]"
          id="nav-evolucao"
          data-toggle="tab"
          href="#evolucao"
          role="tab"
          aria-controls="evolucao"
          aria-selected="true"
          >EVOLUÇÃO ENFERMEIRO(A)</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="
          permission('read', 'resident_nurse_schedule') && step == 'APRAZAMENTO_NORMAL'
        "
        :class="['tab-pane fade', step == 'APRAZAMENTO_NORMAL' && 'show active']"
        id="aprazamento-normal"
        role="tabpanel"
        aria-labelledby="nav-aprazamento-normal"
      >
        <ScheduleNormal />
      </div>
      <div
        v-if="
          permission('read', 'resident_nurse_schedule') &&
          step == 'APRAZAMENTO_LONGO_PRAZO'
        "
        :class="[
          'tab-pane fade',
          step == 'APRAZAMENTO_LONGO_PRAZO' && 'show active',
        ]"
        id="aprazamento-longo-prazo"
        role="tabpanel"
        aria-labelledby="nav-aprazamento-longo-prazo"
      >
        <ScheduleLongTerm />
      </div>
      <div
        v-if="permission('read', 'evolution_nursing') && step == 'EVOLUCAO'"
        :class="['tab-pane fade', step == 'EVOLUCAO' && 'show active']"
        id="evolucao"
        role="tabpanel"
        aria-labelledby="nav-evolucao"
      >
        <Evolution />
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleNormal from "./Nurse/Schedule/Normal";

import ScheduleLongTerm from "./Nurse/Schedule/LongTerm";

import Evolution from "./Nurse/Evolution";

import routes from "../../routes";

import { userData } from "../../lib/functions";

import permission from "../../lib/permission";

export default {
  name: "MenuDoctor",
  components: {
    ScheduleNormal,
    ScheduleLongTerm,
    Evolution,
  },
  data() {
    return {
      step: "APRAZAMENTO_NORMAL",
      rest_home_id: "",
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleStep(step) {
      let newNav;

      if (step == "APRAZAMENTO_NORMAL") {
        newNav = "schedule-normal";
      }

      if (step == "APRAZAMENTO_LONGO_PRAZO") {
        newNav = "schedule-long-term";
      }

      if (step == "EVOLUCAO") {
        newNav = "evolution";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "schedule-normal") {
          this.step = "APRAZAMENTO_NORMAL";
        }
        if (nav == "schedule-long-term") {
          this.step = "APRAZAMENTO_LONGO_PRAZO";
        }
        if (nav == "evolution") {
          this.step = "EVOLUCAO";
        }
      }
    },
  },
};
</script>
